import { useEffect } from "react";
import { useGame } from "@/game/GameContext";
import PixelButton from "@/components/PixelButton";
import PixelPanel from "@/components/PixelPanel";
import AshLogo from "@/components/AshLogo";
import { startMenuMusic, isMusicEnabled } from "@/game/audioEngine";

export default function HowToPlayScreen() {
  const { dispatch } = useGame();

  useEffect(() => {
    if (isMusicEnabled()) startMenuMusic();
  }, []);

  return (
    <div className="min-h-screen px-4 py-10 flex flex-col items-center">
      <div className="w-full max-w-2xl">
        <div className="flex items-center gap-3 mb-6">
          <AshLogo size={40} />
          <span className="ash-byline text-xl">
            <span className="ash">ASH</span><span className="interactive">interactive</span>
          </span>
          <span className="pixel-font text-[10px] text-white/60 tracking-widest ml-2">
            · HOW TO PLAY
          </span>
        </div>

        <PixelPanel>
          <h2 className="pixel-font text-xl md:text-2xl text-[#F26522] mb-4">
            Welcome, trailblazer.
          </h2>
          <p className="text-base md:text-lg leading-relaxed mb-4">
            You're launching a business and trying to survive your first year of marketing.
            Each month, you'll face a new challenge. Make smart choices, watch your stats and
            try to finish the year with the strongest score possible.
          </p>
          <p className="text-base md:text-lg leading-relaxed mb-4">
            If your budget runs out, don't worry. You'll enter <b className="text-[#F26522]">Bootstrap Mode</b> and
            keep pushing forward with grit, free moves and clever choices.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 my-6">
            {[
              ["Awareness", "Who knows you exist"],
              ["Trust", "Who believes in you"],
              ["Leads", "Real opportunities"],
              ["Energy", "Your bandwidth"],
              ["Systems", "Repeatable habits"],
              ["Budget", "Money in the wagon"],
            ].map(([k, d]) => (
              <div key={k} className="bg-[#0F172A] text-white border-4 border-black p-3">
                <div className="pixel-font text-[10px] text-[#F26522] mb-1">{k}</div>
                <div className="text-sm">{d}</div>
              </div>
            ))}
          </div>

          <p className="text-base md:text-lg leading-relaxed">
            The trail lasts 12 months. The whole game takes about 5–7 minutes. Ready, partner?
          </p>
        </PixelPanel>

        <div className="mt-6 flex flex-col sm:flex-row gap-3">
          <PixelButton
            data-testid="how-back-button"
            variant="secondary"
            onClick={() => dispatch({ type: "GOTO", screen: "start" })}
          >
            ← Back
          </PixelButton>
          <PixelButton
            data-testid="how-start-button"
            onClick={() => dispatch({ type: "GOTO", screen: "character" })}
          >
            Pick A Character ▶
          </PixelButton>
        </div>
      </div>
    </div>
  );
}
